export const tab = Object.freeze({
  TODO: 'TODO',
  ALL_BOOKINGS: 'ALL_BOOKINGS',
});
